import { render, staticRenderFns } from "./CmgUnenrolledRewards.vue?vue&type=template&id=5c2af8fd&scoped=true&lang=pug&"
import script from "./cmg-unenrolled-rewards.ts?vue&type=script&lang=ts&"
export * from "./cmg-unenrolled-rewards.ts?vue&type=script&lang=ts&"
import style0 from "./CmgUnenrolledRewards.vue?vue&type=style&index=0&id=5c2af8fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2af8fd",
  null
  
)

export default component.exports